export default "__VITE_PUBLIC_ASSET__3b3e7bfb__"